import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import OutsideClickHandler from 'react-outside-click-handler';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { PRIMARY_COLOR } from '../../shared/styles/Colors';
import { ArrowDown } from '../../assets/customised-svgs/arrow-down';
import { ArrowUp } from '../../assets/customised-svgs/arrow-up';
import { Globe } from '../../assets/customised-svgs/globe';

const languages = ['English', 'العربية'];

const getLanguageName = (language) => {
  switch (language) {
    case 'en':
      return 'English';
    case 'ar':
      return 'العربية';
    default:
      return 'English';
  }
};

const LanguageToggle = ({ login }) => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );

  useEffect(() => {
    localStorage.setItem('language', language);
    i18n.changeLanguage(language);
  }, [i18n, language]);

  const changeLanguagetoAr = () => {
    i18n.changeLanguage(language), setLanguage('ar'), location.reload();
  };
  const changeLanguagetoEn = () => {
    i18n.changeLanguage(language), setLanguage('en'), location.reload();
  };

  const [isActive, setIsActive] = useState(false);

  const dropdownHandler = () => setIsActive(!isActive);

  return (
    <OutsideClickHandler onOutsideClick={() => setIsActive(false)}>
      <ToggleContainer login={login}>
        {isActive ? (
          <DropdownWrapper login={login}>
            {languages.map((language) => (
              <ItemWrapper
                key={language}
                onClick={
                  language === 'English'
                    ? changeLanguagetoEn
                    : changeLanguagetoAr
                }
              >
                {language}
              </ItemWrapper>
            ))}
          </DropdownWrapper>
        ) : null}

        <ToggleWrapper isActive={isActive} onClick={dropdownHandler}>
          <Globe />
          <LanguageName isActive={isActive}>
            {getLanguageName(i18n.language)}
            {isActive ? <ArrowUp /> : <ArrowDown />}
          </LanguageName>
        </ToggleWrapper>
      </ToggleContainer>
    </OutsideClickHandler>
  );
};

const ItemWrapper = styled.a`
  align-items: center;
  color: inherit;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-top: 1px;
  padding: 5px 035px;
  &:hover {
    background: #ff7d6b14 0% 0% no-repeat padding-box;
    border-radius: 4px;
    color: ${PRIMARY_COLOR};
  }

  text-decoration: none;
  &:hover &:focus &:active {
    text-decoration: none;
  }
`;

const LanguageName = styled.span`
  color: ${(props) => (props.isActive ? PRIMARY_COLOR : '')};
  font-size: 14px;
  font-weight: 500;
  margin-left: 10px;
  margin-right: 10px;
`;

const ToggleContainer = styled.div`
  ${(props) =>
    props.login
      ? css`
          position: absolute;
          right: 0;
          top: 1rem;
        `
      : css`
          position: relative;
        `}

  display: flex;
  justify-content: flex-end;
`;

const ToggleWrapper = styled.div`
  border: 1px solid #f5f5f5;
  border-radius: 4px;
  padding: 3px;
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-left: 20px;
  margin-right: 20px;
  padding-left: 10px;

  :hover {
    color: ${PRIMARY_COLOR};
  }
  svg {
    margin-bottom: 2px;
    margin-left: 5px;
  }
  svg.globe {
    margin: auto;
  }
  :hover {
    color: ${PRIMARY_COLOR};
    svg.globe path {
      fill: ${PRIMARY_COLOR};
    }
    svg.arrow-down path {
      stroke: ${PRIMARY_COLOR};
    }
  }
`;

const DropdownWrapper = styled.div`
  background-color: #ffffff;
  bottom: auto;
  box-shadow: 0px 3px 10px 0px rgb(38 107 193 / 8%);
  padding: 10px;
  position: absolute;
  ${(props) =>
    props.login
      ? css`
          top: 35px;
          right: 0;
        `
      : css`
          top: -330%;
          left: 0;
        `}

  z-index: 1;

  .active-lang {
    background: #ff7d6b14 0% 0% no-repeat padding-box;
    border-radius: 4px;
    color: ${PRIMARY_COLOR};
  }
`;

LanguageToggle.propTypes = {
  login: PropTypes.bool,
};

export default LanguageToggle;
